import { VersionLabelText } from '@sba/design-system';
import useIsCommunityPlan from './useIsCommunityPlan';
import useIsFreeTierTenant from './useIsFreeTierTenant';

export default function useVersionLabelText(): VersionLabelText | undefined {
  const isCommunityPlan = useIsCommunityPlan();
  const isFreeTierTenant = useIsFreeTierTenant();

  if (isCommunityPlan) {
    return 'FREE EDITION';
  }
  if (isFreeTierTenant) {
    return 'FREE';
  }
  return undefined;
}
